import apiClient from '@/services/apiClient';

let visitRegistered = false;

export const registerVisit = async () => {
  // Verificar si ya se registró la visita en esta sesión
  if (visitRegistered) {
    return;
  }

  try {
    const response = await apiClient.post('/register-visit/');
    if (response.data && response.data.success) {
      visitRegistered = true;
      console.log('Visita registrada:', response.data);
    }
  } catch (error) {
    console.error('Error al registrar visita:', error);
  }
};

// Registrar visita automáticamente cuando se carga la página
if (typeof window !== 'undefined') {
  // Solo registrar en el cliente
  registerVisit();
} 